import XHRPromise from 'xhr-promise'
import moment from 'moment'

(function () {
    let activeFetch = -1
    const daySelector = document.getElementById('daySelector')  
    const urlParams = new URLSearchParams(window.location.search);
    const bookingId = urlParams.get('brn');

    if (daySelector != null) {
        daySelector.addEventListener("change", () => {
            const hidSelectedDay = document.getElementById('hidSelectedDay')
            hidSelectedDay.value = daySelector.value
            getPaymentSchedule(bookingId, daySelector.value)
        })


        let getPaymentSchedule = async (bookingID, dayOfMonth) => {
            const feedEndpoint = `/feeds/paymentScheduleFeed.aspx?bookingID=${bookingID}&dayOfMonth=${dayOfMonth}`

            try {
                if (activeFetch !== -1) {
                    activeFetch.getXHR().abort()
                }

                activeFetch = new XHRPromise()
                const response = await activeFetch.send({
                    url: feedEndpoint,
                })
                const data = response.responseText
                updateUI(data)
                activeFetch = -1
            } catch (error) {
                if (error.reason !== 'abort') {
                    console.log(error)
                }
            }
        };

        let updateUI = (data) => {

            let finalPayment = data.Table[data.Table.length - 1].Amount

            // Filter the table to only include rows with PaymentId as null
            const filteredTable = data.Table.filter(row => row.PaymentId === null)

            let noOfPayments = filteredTable.length
            let monthlyPayments = filteredTable[0].Amount

            const paymentSummary = document.getElementById('paymentSummary')

            if (monthlyPayments === finalPayment) {
                paymentSummary.innerText = `You will be charged ${formatCurrency(monthlyPayments)} for ${noOfPayments} months.`
            } else {
                noOfPayments--; // Remove the final payment from the count
                paymentSummary.innerText = `You will be charged ${formatCurrency(monthlyPayments)} for ${noOfPayments} months and then a final payment of ${formatCurrency(finalPayment)}.`
            }
        }

        // Function to format number as currency
        const formatCurrency = (amount) => {
            return Number(amount).toLocaleString('en-GB', {
                style: 'currency',
                currency: 'GBP'
            })
        }

        getPaymentSchedule(bookingId, 1)
    }    
})()

